module.exports = __webpack_public_path__ + "static/media/orencash4.a91ee2d6.jpg";